import { parseAiTags } from './mcpbTimeline';

/**
 * mcpbFilter — apply the committed "Filter by" selection to the clip set (client-side, per the plan:
 * getEventsByTime returns ALL clips in the window; narrowing happens here off fArchive/fExport/sTags).
 *
 * All filters are OFF by default = get EVERYTHING; selecting a criterion restricts to clips meeting it
 * (David 2026-06-19, supersedes the old "AI-on" default). Two facets, AND-combined; OR within a facet:
 *   - STATUS (archived / export): if either is selected, the clip must carry a selected flag
 *     (archived→fArchive, export→fExport); both → flagged either way. ("Select Export → only video
 *     flagged for export"; same for Archive.)
 *   - CONTENT / AI tags (person / vehicle / alert): if ANY is selected, the clip's sTags must include a
 *     selected type (so selecting all three = only AI-tagged clips; selecting none = no content limit).
 * Nothing selected in a facet → that facet doesn't restrict.
 */

const AI_TYPES = ['person', 'vehicle', 'alert'];

export const clipMatchesFilters = (clip, filters = {}) => {
  if (!clip) return false;

  // Status facet — restrictive when any status flag is selected.
  const wantArchive = !!filters.archived;
  const wantExport = !!filters.export;
  if (wantArchive || wantExport) {
    const hasSelectedFlag = (wantArchive && !!clip.fArchive) || (wantExport && !!clip.fExport);
    if (!hasSelectedFlag) return false;
  }

  // Content facet — restrictive when any AI tag is selected (OR within the facet).
  const selectedAi = AI_TYPES.filter((t) => filters[t]);
  if (selectedAi.length > 0) {
    const tags = parseAiTags(clip.sTags);
    if (!selectedAi.some((t) => tags.includes(t))) return false;
  }

  return true;
};

/** Apply clipMatchesFilters to every track in a {key: [clips]} map; returns a new map (keys preserved). */
export const filterTrackEvents = (trackEvents = {}, filters = {}) => {
  const out = {};
  Object.keys(trackEvents || {}).forEach((key) => {
    out[key] = (trackEvents[key] || []).filter((clip) => clipMatchesFilters(clip, filters));
  });
  return out;
};
